var _defs, _polyline, _polyline2, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _line7, _circle, _polyline3, _polyline4, _polyline5, _polyline6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparentCoveragecopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;stroke-width:9.81px;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "242.78 85.18 291.25 85.18 291.25 204.06"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "291.25 370.36 291.25 388.17 67.15 388.17 67.15 85.18 116.89 85.18"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.23,
    y1: 150.08,
    x2: 269.87,
    y2: 150.08
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 154.7,
    y1: 176.09,
    x2: 233.82,
    y2: 176.09
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.23,
    y1: 316.81,
    x2: 166.95,
    y2: 316.81
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 154.7,
    y1: 342.82,
    x2: 179.2,
    y2: 342.82
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.23,
    y1: 259.46,
    x2: 165.57,
    y2: 259.46
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 154.7,
    y1: 233.45,
    x2: 176.44,
    y2: 233.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m203.08,66.98c-2.59-10.45-12-18.2-23.25-18.2s-20.66,7.76-23.25,18.2h-25.85v39.23h98.2v-39.23h-25.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m360.6,362.11l16.8,15.5c5.05,4.66,5.36,12.52.71,17.57l-.55.6c-4.66,5.05-12.52,5.36-17.57.71l-52.53-48.47,17.42-18.88,11.82,10.91,23.92,22.06Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 314.67,
    y1: 336.86,
    x2: 296.73,
    y2: 320.31
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 248.35,
    cy: 279.43,
    r: 63.35
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "215.31 281.6 241.26 306.63 281.39 248.56"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "94.6 164.53 107.5 177.44 132.76 144.78"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "94.6 248.79 107.5 261.69 132.76 229.04"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "94.6 333.04 107.5 345.94 132.76 313.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentCoveragecopy2);
export default __webpack_public_path__ + "static/media/Transparent Coverage copy 2.d070807d8452f2e15878585865f90ade.svg";
export { ForwardRef as ReactComponent };